import cropImage from './image_crop';

const t = key => I18n.t(`user_account.image_editor.${key}`);
const types = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

function button(label, action) {
  const element = document.createElement('button');
  element.type = 'button';
  element.className = 'btn btn-outline-secondary btn-sm';
  element.textContent = t(label);
  element.addEventListener('click', action);
  return element;
}

async function editImage(options) {
  const dialog = document.createElement('dialog');
  dialog.className = 'rounded border p-3';
  dialog.style.cssText = 'width:720px;max-width:95vw;max-height:95vh;overflow:auto';
  const heading = document.createElement('h2');
  heading.className = 'fs-5'; heading.textContent = t('title');
  const input = document.createElement('input');
  input.type = 'file'; input.accept = types.join(','); input.className = 'form-control mb-3';
  input.setAttribute('aria-label', t('choose'));
  const preview = document.createElement('img');
  preview.className = 'img-fluid rounded mb-3'; preview.style.maxHeight = '320px'; preview.alt = '';
  let file = options.file, objectURL, source = options.url || '';
  const animated = () => file?.type === 'image/gif' || /\.gif(?:\?|$)/i.test(source);
  preview.hidden = !source;
  if (source) preview.src = source;
  const alt = document.createElement('input');
  alt.className = 'form-control mb-3'; alt.maxLength = 500; alt.value = options.alt || '';
  const label = document.createElement('label');
  label.className = 'form-label d-block'; label.textContent = t('alt'); label.append(alt);
  const error = document.createElement('p');
  error.className = 'text-danger'; error.setAttribute('role', 'alert');
  const setFile = selected => {
    if (!types.includes(selected.type) || selected.size > 10 * 1024 * 1024) throw new Error('file');
    file = selected;
    if (objectURL) URL.revokeObjectURL(objectURL);
    source = objectURL = URL.createObjectURL(file); preview.src = source; preview.hidden = false;
    crop.disabled = animated(); error.textContent = '';
  };
  input.addEventListener('change', () => {
    try { if (input.files[0]) setFile(input.files[0]); }
    catch (_) { error.textContent = t('error'); }
  });
  const crop = button('crop', async () => {
    if (!source) { error.textContent = t('choose'); return; }
    try { await cropImage(source, file?.name || 'user-account-image.png', setFile, t); }
    catch (_) { error.textContent = t('crop_error'); }
  });
  crop.disabled = animated();
  const apply = button('apply', async () => {
    if (apply.disabled) return;
    apply.disabled = true; input.disabled = true; crop.disabled = true; error.textContent = '';
    try {
      if (!source) throw new Error('file');
      await options.apply({file, alt: alt.value.trim()});
      dialog.close();
    } catch (_) { error.textContent = t('error'); }
    finally { apply.disabled = false; input.disabled = false; crop.disabled = animated(); }
  });
  apply.className = 'btn btn-primary';
  const actions = document.createElement('div'); actions.className = 'd-flex gap-2';
  actions.append(crop, button('cancel', () => dialog.close()), apply);
  const help = document.createElement('p'); help.className = 'form-text';
  help.textContent = I18n.t('user_account.image_help');
  dialog.append(heading, input, preview, label, help, actions, error);
  document.body.append(dialog);
  dialog.addEventListener('close', () => {
    if (objectURL) URL.revokeObjectURL(objectURL);
    dialog.remove();
  }, {once: true});
  dialog.addEventListener('focusin', event => event.stopPropagation());
  dialog.showModal();
}

export default function installUserAccountImage(root, data = {}) {
  if (!root || root.dataset.accountImageInstalled) return;
  root.dataset.accountImageInstalled = 'true';
  const input = root.querySelector('#user-account-image');
  const alt = root.querySelector('#user-account-image-alt');
  const preview = root.querySelector('#user-account-image-preview');
  const remove = root.querySelector('#user-account-remove-image');
  alt.value = data.image_alt || '';
  let objectURL, source = data.image || '';
  const show = () => { preview.hidden = remove.checked || !source; if (source) preview.src = source; };
  const select = file => {
    if (objectURL) URL.revokeObjectURL(objectURL);
    source = objectURL = URL.createObjectURL(file);
    remove.checked = false;
    show();
  };
  input.addEventListener('change', () => { if (input.files[0]) select(input.files[0]); });
  remove.addEventListener('change', () => { if (remove.checked) input.value = ''; show(); });
  root.querySelector('#user-account-image-actions').append(button('title', () => editImage({
    url: preview.hidden ? '' : source, file: input.files[0], alt: alt.value,
    apply: result => {
      if (result.file) {
        const files = new DataTransfer(); files.items.add(result.file); input.files = files.files;
        select(result.file);
      }
      alt.value = result.alt;
    }
  })));
  show();
  window.addEventListener('pagehide', () => { if (objectURL) URL.revokeObjectURL(objectURL); }, {once: true});
}
